<template>
  <v-content pa-0 id="search-page">
    <Header></Header>

    <loading :active.sync="isLoading"></loading>

    <!-- Title -->
    <div class="search-title cea-bgcolor">
      <v-container fill-height>
        <v-row >
          <v-col>
            <h1 class="text-left text-uppercase">{{ $t('page.search.title') }}</h1>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="search-main">
      <!-- Search Form -->
      <v-container class="search-form">
        <v-row>
          <v-col class="text-left cea-color form-caption text-uppercase">
            {{ $t('page.search.form.caption') }}
          </v-col>
        </v-row>

        <v-layout>
          <v-flex pr-3 shrink>
            <v-text-field
              v-model="searchForm.keyword"
              :placeholder="$t('search')"
              hide-details
              solo>
            </v-text-field>
          </v-flex>
          <v-flex shrink>
            <v-btn
              @click="submitSearch"
              dark
              color="#FF4F23"
              depressed>
              {{ $t('search') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- Search Result -->
      <v-container class="search-result">
        <!-- Search type -->
        <v-row class="mb-3">
          <v-col class="text-left cea-color text-uppercase">
            <h1>{{ $t('page.search.main.search-result-for') }}</h1>
          </v-col>
        </v-row>

        <v-row class="mb-3">
          <v-col class="text-left cea-color text-uppercase">
            <div>{{ $t('page.search.main.search-type') }}</div>
          </v-col>
        </v-row>

        <v-layout class="mb-4">
          <v-flex pr-3 shrink>
            <v-btn
              :outlined="searchType !== 'data-and-statistic'"
              @click="searchType = 'data-and-statistic'"
              dark
              color="#FF4F23"
              depressed>
              {{ $t('data-and-statistic') }}
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn
              :outlined="searchType !== 'research-report'"
              @click="searchType = 'research-report'"
              dark
              color="#FF4F23"
              depressed>
              {{ $t('research-report') }}
            </v-btn>
          </v-flex>
        </v-layout>

        <!-- Search result -->
        <template v-if="!isLoading">
          <template v-if="searchType === 'data-and-statistic'">
            <StatisticList></StatisticList>
          </template>

          <template v-if="searchType === 'research-report'">
            <ReportGroup group="report" :list="activeArticles"></ReportGroup>
          </template>
        </template>
      </v-container>
    </div>

    <Footer></Footer>
  </v-content>
</template>

<script>

  import { mapState, mapActions } from 'vuex'
  import { domain } from "../services/Constants"
  import Header from '../components/Header'
  import Footer from '../components/Footer'
  import Service from '../services'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { chartType } from '../utils/Constants'
  import { yearFormat } from "../utils/Utils"
  import StatisticList from '../components/StatisticList.component'
  import ReportGroup from '../components/ReportGroup'

  export default {
    name: "search",
    components: {
      Header,
      Footer,
      Loading,
      StatisticList,
      ReportGroup,
    },
    props: ['keyword'],
    data: () => ({
      http: domain,
      isLoading: false,

      chartType: chartType,
      yearFormat: yearFormat,
      output: null,

      isPreviewChartExportDialogShow: false,

      activeArticles: [],

      searchType: 'data-and-statistic',
      searchForm: {
        keyword: ''
      }
    }),
    computed: {
      ...mapState({
        overviewGraphs: state => state.statistic.overview.graphs,
        dataAndStatsGraphs: state => state.statistic.dataAndStats.graphs,
        statistic: state => state.statistic,
        selectYear: function (state) {
          return state.statistic.availableYears.map((year) => {
            return {
              text: this.yearFormat(year, this.$i18n.locale),
              value: year
            }
          })
        },
        selectedYear: state => state.statistic.selectedYear,
        allDataTopic: state => state.overview.allDataTopic,
        language: state => state.locale.language
      }),
      sectionOverview: function () {
        return this.overview;
      }
    },
    watch: {
      searchType: function(type) {
        this.initData()
      }
    },
    created() {
      // Google analytic page view
      Service.analytics.sendPageView({
        path: this.$route.path
      })
    },
    methods: {
      ...mapActions('statistic', ['populateStatistics']),
      async initData() {
        this.isLoading = true

        switch (this.searchType) {
          case 'data-and-statistic':
            await this.populateStatistics({
              keyword: this.searchForm.keyword,
              lang: this.language
            })
            break

          case 'research-report':
            const params = {
              paginate: false
            }
            params[`name_${this.language}`] = this.searchForm.keyword

            await Service.webdata
              .getArticlesWithParams(params)
              .then(data => {
                this.activeArticles = data
              })
            break
        }

        this.isLoading = false
      },
      submitSearch() {
        this.initData(this.searchForm.keyword)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../assets/css/constants';

  .search-title {
    height: 222px;
    padding-top: 90px;
    letter-spacing: 1px;
    h1 {
      color: #fff;
      font-size: 32px;
    }
  }

  .search-main {
    letter-spacing: 1px;
    .search-form {
      padding-top: 40px;
      padding-bottom: 40px;
      .form-caption {
        font-size: 18px;
        font-weight: bold;
      }
      .v-text-field {
        border-radius: 0;
        border: 2px solid $cea-color;
      }
      .v-btn {
        font-size: 18px;
        border-radius: 0;
        height: 52px;
        font-weight: lighter;
      }
    }

    .search-result {
      .v-btn {
        font-size: 18px;
        border-radius: 0;
        height: 52px;
        font-weight: lighter;
        border-width: 2px;
      }
    }
  }
</style>
